import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProcessMasterService {

  constructor(private http: HttpClient, private httpService: HttpService) {

  }

  getProcessList() {
      var request = {
          URL: "process/"
      }
      return this.httpService.get(request);
  }

  getProcessListByProcessType(processType: string) {
      var request = {
          URL: "process/processType/" + processType,
      }
      return this.httpService.get(request);
  }

  getMeetingTypeList() {
      var request = {
          URL: "meetingType/"
      }
      return this.httpService.get(request);
  }

  addProcess(newProcess) {
      var request = {
          URL: "process",
          DATA: newProcess
      }
      return this.httpService.post(request);

  }

  getProcessById(processId: string) {
      var request = {
          URL: "process/"+ processId
      }
      return this.httpService.get(request);

  }

  deleteProcess(processId) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.pssServerUrl + 'process/delete/' + processId, { headers: headers })
          .map(res => res);
  }

  updateProcess(updatedProcess) {
      var request = {
          URL: "process/edit/"+ updatedProcess.ProcessId,
          DATA: updatedProcess
      }
      return this.httpService.post(request);
  }

  getActivatedProcessList() {
      var request = {
          URL: "getActivatedProcessList/"
      }
      return this.httpService.get(request);
  }

  getTaskParticularsByProcessId(processId) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.pssServerUrl + 'getTaskParticularsByProcessId/' + processId, { headers: headers })
          .map(res => res);
  }

  addProcessandaddtasktoProcess(newProcess) {
      var request = {
          URL: "addprocess",
          DATA: newProcess
      }
      return this.httpService.post(request);

  }

  addProcessandactivateProcess(newProcess) {
      var request = {
          URL: "addProcessandActivate",
          DATA: newProcess
      }
      return this.httpService.post(request);
  }

  updateProcessandactivateProcess(updatedProcess) {
      var request = {
          URL: "updateProcessandActivate/" + updatedProcess.ProcessId,
          DATA: updatedProcess
      }
      return this.httpService.post(request);
  }

  updateProcessandaddtasktoProcess(updatedProcess) {
      var request = {
          URL: "updateProcess/" + updatedProcess.ProcessId,
          DATA: updatedProcess
      }
      return this.httpService.post(request);

  }

  reOrderRowsArraysforProcess(reorderArrays, processID) {
      var request = {
          URL: "reOrderProcessTasks/" + processID,
          DATA: reorderArrays
      }
      return this.httpService.post(request);
  }

  getActivatedProcessListwithPendingandPartiallyCompletedStatus() {
      var request = {
          URL: "getPendingandPartiallyCompletedActivatedProcessList/"
      }
      return this.httpService.get(request);
  }

  getActivatedProcessListBySerachFilters(searchParameters) {
      var request = {
          URL: "getActivatedProcessListBySerachFilters/",
          DATA: searchParameters
      }
      return this.httpService.post(request);
  }

  verifyProcessData(conditions)
  {
      var request = {
          URL: "verifyProcessData/",
          DATA: conditions
      }
      return this.httpService.post(request);
  }

}